<template>
  <div class="container">
    <span @click="abrirModal()" class="btn btn-small button-larges btn-sobre z-depth-3 cor-primaria-bg">Sobre a loja</span>
    <div class="funcionamento">

      <div class="icones-empresa" v-if="this.$store.state.empresa.receber_pedidos_whatsapp == 'S'">
        <i class="fab fa-whatsapp " style="padding-right: 7px;font-size: 23px"></i>
        <span @click="abrirWhats()">{{ this.formatarWhats() }}</span>
      </div>

      <div class="icones-empresa">
        <span class="material-icons md-24">schedule</span>
        ENTREGA - {{ this.$store.state.empresa.tempo_medio_entrega ? this.$store.state.empresa.tempo_medio_entrega.toUpperCase() : '' }}
      </div>
      <a class="icones-empresa" :href="'https://maps.google.com/?q=' + this.$store.state.empresa.endereco + ', ' + this.$store.state.empresa.numero + ' Bairro ' + this.$store.state.empresa.bairro" target="_blank" style="color:black">
        <span class="material-icons md-24">location_on</span>
        {{getEndereco()}}
      </a >
      <!-- <div class="icones-empresa" v-if="this.$store.state.empresa.habilitar_taxa_entrega == 'S'">
        <span class="material-icons md-24">motorcycle</span>ENTREGA
        <b>&nbsp;{{ this.$store.state.empresa.forma_cobranca_frete != 'BAIRRO' ? '- R$ ' + this.$store.state.empresa.taxa_entrega : ' A partir de ' + tarifaEntregaMinima}}</b>
      </div> -->
      <div class="icones-empresa">
        <span class="material-icons md-24">motorcycle</span>
        ENTREGA &nbsp; - &nbsp<b>{{ this.$store.state.empresa.empresa_frete_detalhes }}</b>
      </div>      
      <span v-if="empresa.aberto == 'S'" class="a-status materialize-green">ABERTO</span>
      <span v-else class="a-status materialize-red">FECHADO</span>
    </div>

    <!-- Modal Structure -->
    <div id="modalHorarios" class="modal modal-fixed-footer" style="z-index: 10003 !important;">
      <div class="modal-content">
        <div class="row">
          <h5 class="col s12 center-align " style="margin-top: 0">Sobre a Loja</h5>
        </div>
        <titulo-destacado :titulo="this.$store.state.empresa.nome"></titulo-destacado>
        <div class="row">
          <span class="col s12">
            <strong>Endereço: </strong> {{this.getEndereco()}}
          </span>
        </div>

        <titulo-destacado titulo="Horário de Atendimento"></titulo-destacado>
        <ul v-if="this.$store.state.empresa.forma_exibicao_horario == 'TABELA'">
          <li v-for="horario in this.$store.state.empresa.horarios" :key="horario.dia" :class="'row' + ($store.state.empresa.dia_semana == horario.dia ? ' text-bold' : '')">
            <span class="col s3">{{horario.descricao}}</span>
            <span class="col s9">{{horario.horarios}}</span>
          </li>
        </ul>
        <div v-else class="row">
          <span class="col s12">
            {{ this.$store.state.empresa.horario_funcionamento.toLocaleUpperCase() }}
          </span>
        </div>

        <titulo-destacado titulo="Formas de pagamento"></titulo-destacado>
        <div class="row">
          <span class="col s12" v-if="this.$store.state.empresa.pagamento_dinheiro == 'S'">Dinheiro</span>
          <span class="col s12" v-if="this.$store.state.empresa.pagamento_debito == 'S'">Cartão de Débito</span>
          <span class="col s12" v-if="this.$store.state.empresa.pagamento_credito == 'S'">Cartão de Crédito</span>
          <span class="col s12" v-if="this.$store.state.empresa.pagamento_transferencia == 'S'">Transferência</span>
          <span class="col s12" v-if="this.$store.state.empresa.pagamento_boleto == 'S'">Boleto</span>
          <span class="col s12" v-if="this.$store.state.empresa.pagamento_pix == 'S'">PIX</span>
        </div>

      </div>
      <div class="modal-footer cor-primaria-border">
        <a class="modal-close waves-effect btn-flat cor-primaria-text">Fechar</a>
      </div>
    </div>
  </div>
</template>

<script>
  import { WMCompose, WMSend } from '@aninga/whatsapp-manager'
  import TituloDestacado from '../views/template/TituloDestacado';

  export default {
    name: "InformacoesEmpresa",
    data() {
      return {
        tarifaEntregaMinima: 0,
        empresa: this.$store.state.empresa
      };
    },
    components: { TituloDestacado },
    methods: {

      formatarWhats() {
        var numero = this.$store.state.empresa.whatsapp;

        if (numero.startsWith("55"))
          numero = numero.slice(2);

        if (numero.length < 10)
          return numero;

        numero = numero.replace(/^(\d{2})(\d)/g, "($1) $2");
        numero = numero.replace(/(\d)(\d{4})$/, "$1-$2");

        return numero;
      },
      getEndereco(){
        if(this.empresa.cidade_id != null){
            return this.empresa.cidade.cidade + ' / ' + this.empresa.cidade.uf + ' - ' +
               this.empresa.endereco.toLocaleUpperCase() + ', ' +
               this.empresa.numero + ' - ' +
               (this.empresa.complemento ? (this.empresa.complemento.toLocaleUpperCase() + ' - ') : '') +
               this.empresa.bairro.toLocaleUpperCase();
        }else{
          return this.empresa.endereco.toLocaleUpperCase() + ', ' +
            this.empresa.numero + ' - ' +
            (this.empresa.complemento ? (this.empresa.complemento.toLocaleUpperCase() + ' - ') : '') +
            this.empresa.bairro.toLocaleUpperCase();
        }


      },
      abrirWhats() {
        WMSend(this.$store.state.empresa.whatsapp, "");
      },
      abrirModal() {
        $("#modalHorarios").modal("open");
      }
    },
    mounted() {
      $("#modalHorarios").modal();
      var tarifas = this.$store.state.empresa.tarifas_entrega_bairro;
      if (tarifas.length > 0) {
        this.tarifaEntregaMinima =
          " R$ " +
          tarifas
            .reduce((min, b) => Math.min(min, b.valor), tarifas[0].valor)
            .toFixed(2);
      }
    }
  };
</script>

<style scoped>
  .modal {
    top: 3% !important;
    width: 94% !important;
    max-width: 100% !important;
    height: 94% !important;
    max-height: 100% !important;
    z-index: 10003;
  }
  .modal .modal-content {
    margin-top: 4px;
    padding: 0 5px !important;
  }
  .modal .modal-content ul,
  .modal .modal-content div.row {
    margin: 0;
    padding: 12px 8px;
  }
  .modal .modal-content ul li {
    margin-bottom: 8px;
  }
  .funcionamento {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    -webkit-box-pack: justify;
    justify-content: space-between;
    padding: 15px 20px 5px 20px;
    margin: 0px auto;
  }
  .a-status {
    position: absolute;
    right: 12px;
    top: 12px;
    padding: 8px;
    border-radius: 10px;
    display: flex;
    align-items: flex-start;
    -webkit-box-pack: center;
    justify-content: center;
    color: white;
    white-space: nowrap;
  }
  .icones-empresa {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: start;
    justify-content: flex-start;
    -webkit-box-align: start;
    align-items: start;
    line-height: 2;
    font-size: 0.9rem;
    margin-bottom: 8px;
  }
  .icones-empresa .material-icons,
  .icones-empresa svg {
    margin-right: 8px;
  }
  .btn-sobre {
    position: absolute;
    top: 190px;
    right: 8px
  }

  @media screen and (max-height: 640px) {
    .btn-sobre {
      top: 180px;
    }
  }
  @media screen and (max-height: 540px) {
    .btn-sobre {
      top: 120px;
    }
  }

  .materialize-green {
    background-color: #27ae61;
  }


  .button-larges{
    text-decoration: none;
    display: inline-block;
    text-align:center;
    font-size: 10px;
    /*font-weight: bold;*/
    line-height: 15px;
    padding: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/app/components/InformacoesEmpresa.vue